import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApprovalDetail } from '../../model/approval/approval-info';
import { ApprovalListType } from '../../enums/approval/approval.enum';

@Injectable({
    providedIn: 'root'
})
export class ApprovalService {

    approvalAPI: string;
    coreUrl: string;
    notificationApi: string;

    constructor(private http: HttpClient) {
        this.approvalAPI = environment.approvalAPI;
        this.coreUrl = environment.coreUrl;
        this.notificationApi = environment.notificationUrl2;
    }

    //addApproval
    addApproval(ApprovalData: ApprovalDetail): Observable<any> {
        return this.http.post<any>(`${this.approvalAPI}Approval/Information/${ApprovalData.approvalId}`, ApprovalData);
    }
    //update Appproval
    updateApproval(approvalId, approvalData: ApprovalDetail, queryParams?: { [key: string]: any }): Observable<any> {
        let params = new HttpParams()

        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                // Ensure the value is a string
                const value = queryParams[key];
                params = params.set(key, value != null ? value.toString() : '');
            });
        }
        return this.http.put<any>(`${this.approvalAPI}Approval/${approvalId}`, approvalData, { params });
    }



    //getApprovalCountByUserId
    getApprovalCountByUserId(userId: number, approvalListType: ApprovalListType): Observable<any> {
        return this.http.get<any>(`${this.approvalAPI}Approval/Count/${userId}?status=1&listType=${approvalListType}`);
    }

    //getApprovalPagedList
    getApprovalPagedList(pageNumber: number, pageSize: number, status?: number, approvalStatus?: number, options?): Observable<any> {
        let url = `${this.approvalAPI}Approval/PagedList?PageNumber=${pageNumber}&PageSize=${pageSize}&status=${status || 1}`;
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
        }

        // default sorting
        const sortBy = options?.sort ?? true; // Default to `true` if `options.sort` is null or undefined
        if (!sortBy) {
            url = `${url}&SortBy=lastUpdated&IsAscending=false`;
        }

        if (approvalStatus) {
            url = `${url}&approvalStatus=${approvalStatus}
            `;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    //GetApprovedPagedListByUser
    getApprovedPagedListByUser(userId: number, pageNumber: number, pageSize: number, status: number, approvalStatus: number, moduleSearchValue: string, approvalListType: ApprovalListType, options?): Observable<any> {
        let url = `${this.approvalAPI}Approval/PagedListByUserId/${userId}?PageNumber=${pageNumber}&PageSize=${pageSize}&listType=${approvalListType}&status=${status || 1}`;
        if (moduleSearchValue.length > 1) {
            url = `${url}&ModuleSearchValue=${encodeURIComponent(moduleSearchValue)}`;
        }
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
        }

        // default sorting
        const sortBy = options?.sort ?? true;
        if (!sortBy) {
            url = `${url}&SortBy=lastUpdated&IsAscending=false`;
        }

        if (approvalStatus) {
            url = `${url}&approvalStatus=${approvalStatus}
            `;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    //getApprovalDetailsById
    getApprovalDetailsById(id: number, approvalInfoId: number, status: number) {
        const url = `${this.approvalAPI}Approval/${id}?approvalInfoId=${approvalInfoId}&status=${status || 1}`;
        return this.http.get<any>(url);
    }

    //getApprovalDetailsByType
    getApprovalDetailsByType(approvalType: number, approvalTypeId: number, status: string, approvalTypeNumber?: string,) {
        let url = `${this.approvalAPI}Approval/ApprovalType/${approvalType}/ApprovalTypeId/${approvalTypeId}?status=${status}`;
        if (approvalTypeNumber) {
            url += `&approvalTypeNumber=${approvalTypeNumber}`;
          }
        return this.http.get<any>(url);
    }

     //getApprovalDetailsEncryptedKey
     getApprovalDetailsByKey(encryptedKey : number) {
        const url = `${this.approvalAPI}Approval/Key/${encryptedKey}`;
        return this.http.get<any>(url);
    }   
    
}